import { render, staticRenderFns } from "./ProgramChanges.vue?vue&type=template&id=239bf404"
import script from "./ProgramChanges.vue?vue&type=script&lang=js"
export * from "./ProgramChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports